import {createListenerMiddleware, isAnyOf} from '@reduxjs/toolkit';
import {setDoc} from 'firebase/firestore';
import {auth} from '../../firebase/firebase';
import {userDoc} from '../../firebase/firestore';
import {toggleFavorite} from '../slices/favorites/reducers';
import {toggleLike, removeLikedSong} from '../slices/likedSongs/reducers';
import {updateRecentlyPlayed} from '../slices/user/actions';
import type {RootState} from '../store';

export const userDataSyncMiddleware = createListenerMiddleware();

// Mirror per-user state (favorites, liked songs, recently played) to users/{uid}.
// `setAllFavorites` / `setAllLikedSongs` and `user.setValue` are deliberately NOT
// matched — those are the channels through which remote state is applied locally,
// so echoing them would loop. We listen to the local mutation actions instead.
userDataSyncMiddleware.startListening({
    matcher: isAnyOf(
        toggleFavorite,
        toggleLike,
        removeLikedSong,
        updateRecentlyPlayed.fulfilled,
    ),
    effect: async (_action, api) => {
        const uid = auth.currentUser?.uid;
        if (!uid) return;

        // Coalesce bursts (rapid like-toggles, recentlyPlayed updates that fire on
        // every track change) into a single write.
        api.cancelActiveListeners();
        await api.delay(500);

        const state = api.getState() as RootState;
        const payload = {
            favorites: state.favorites.playlists,
            likedSongs: {
                songs: state.likedSongs.songs,
                order: state.likedSongs.order,
            },
            recentlyPlayed: state.user.recentlyPlayed,
            updatedAt: Date.now(),
        };

        try {
            await setDoc(userDoc(uid), payload);
        } catch (err) {
            console.error('Firestore user-data sync (write) failed', err);
        }
    },
});
